// components/Shop.js
import React from 'react';
import './Shop.css'; // Importing the CSS file

const Shop = () => {
  return (
    <div className="shop-container">
      <h1>Shop Page</h1>
      <p>Browse and shop for our products here.</p>
    </div>
  );
};

export default Shop;
